module.exports = __webpack_public_path__ + "img/signature-clinic.2ace8ee7.png";